import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import CustomerProofView from "@/components/mobile/CustomerProofView";
import { CUSTOMER_PROOF_PAGE_CSS } from "@/lib/customerProofPageStyles";
import { MOBILE_CAKE_PROOF_CSS, PRODUCTION_DRIVER_PAGE_CSS } from "@/lib/productionDriverPageStyles";
import { appPathname } from "@/lib/opsBase";

export default function FrostingProofPage() {
  const [info, setInfo] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    const match = appPathname().match(/^\/p\/frosting-proof\/([A-Za-z0-9]+)\/?$/i);
    const code = match?.[1];
    if (!code) {
      setErr("Invalid link.");
      return;
    }

    let cancelled = false;
    fetch(`/api/p/frosting-proof/${encodeURIComponent(code)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}));
        if (cancelled) return;
        if (!r.ok) {
          setErr(
            typeof data.detail === "string"
              ? data.detail
              : "This link is invalid or expired."
          );
          return;
        }
        setInfo(data);
      })
      .catch(() => {
        if (!cancelled) setErr("Could not load your cake. Check your connection and try again.");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const pageCss = `${CUSTOMER_PROOF_PAGE_CSS}${PRODUCTION_DRIVER_PAGE_CSS}${MOBILE_CAKE_PROOF_CSS}`;

  if (!info && !err) {
    return (
      <div className="customer-proof-page">
        <style>{pageCss}</style>
        <div className="customer-proof-loading">
          <Loader2 className="h-8 w-8 animate-spin" style={{ color: "#EE2677" }} />
          <p className="customer-proof-loading-text">Loading your cake…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="customer-proof-page">
      <style>{pageCss}</style>
      {err ? (
        <div className="customer-proof-error">
          <p className="customer-proof-error-title">Link not available</p>
          <p className="customer-proof-error-text">{err}</p>
        </div>
      ) : (
        <CustomerProofView info={info} />
      )}
    </div>
  );
}
